import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Grid, Wrapper, H } from 'components/common'
import { COLOR, GTR } from 'styles/tokens'
import ScrollTo from 'components/ScrollTo'

import { COPY } from './constants'

const StyledHeaderWrapper = styled(Wrapper)`
  background-color: ${COLOR.GREY.DARK};
  color: ${COLOR.WHITE};
`

const StyledContent = styled.ul`
  li {
    &:not(:last-of-type) {
      margin-bottom: ${GTR.XS};
    }

    &:hover {
      color: ${COLOR.ACCENT.PRIMARY};
    }
  }
`

const Terms = ({ name, split }) => {
  const { intro, title, subTitle, sections } = COPY[name]

  const half = Math.round(sections.length / 2)
  const left = split ? sections.slice(0, half) : sections
  const right = split ? sections.slice(half) : null

  return (
    <>
      <StyledHeaderWrapper>
        <Grid container>
          <Grid.Item spanFromL={10} startColumnFromL={2}>
            <H centered size="XL" margin={[0, 0, 'XL']}>
              {title}
            </H>
            <Wrapper>
              <H size="L" color={COLOR.ACCENT.PRIMARY}>
                {subTitle}
              </H>
              <Grid gap="XS" gapFromL="L">
                <Grid.Item spanFromL={6}>
                  <StyledContent>
                    {left.map((section, index) => (
                      <li key={`${section.title} List`}>
                        <ScrollTo scrollId={index + 1}>
                          {index + 1}. {section.title}
                        </ScrollTo>
                      </li>
                    ))}
                  </StyledContent>
                </Grid.Item>
                {right && (
                  <Grid.Item spanFromL={6}>
                    <StyledContent>
                      {right.map((section, index) => (
                        <li key={`${section.title} List`}>
                          <ScrollTo scrollId={index + half + 1}>
                            {index + half + 1}. {section.title}
                          </ScrollTo>
                        </li>
                      ))}
                    </StyledContent>
                  </Grid.Item>
                )}
              </Grid>
            </Wrapper>
          </Grid.Item>
        </Grid>
      </StyledHeaderWrapper>
      <Grid container>
        <Grid.Item spanFromL={10} startColumnFromL={2}>
          {intro &&
            intro.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {sections.map((section, index) => (
            <Wrapper key={section.title} separator data-scroll-id={index + 1}>
              <H size="S">
                {index + 1}. {section.title}
              </H>
              {section.content.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </Wrapper>
          ))}
        </Grid.Item>
      </Grid>
    </>
  )
}

Terms.propTypes = {
  name: PropTypes.string.isRequired,
  split: PropTypes.bool,
}

Terms.defaultProps = {
  split: false,
}

export default Terms
